export function formatRemainingTime(
  elapsedMs: number,
  current: number,
  total: number,
): string {
  const avgMs = elapsedMs / current;
  const remainingMs = avgMs * (total - current);
  const totalSecs = Math.round(remainingMs / 1000);
  if (totalSecs < 60) {
    return `~${totalSecs}s`;
  }
  const mins = Math.floor(totalSecs / 60);
  const secs = totalSecs % 60;
  if (mins < 60) {
    return `~${mins}m ${secs}s`;
  }
  const hours = Math.floor(mins / 60);
  const remMins = mins % 60;
  return `~${hours}h ${remMins}m`;
}
